import { createSelector } from 'reselect'
// import { List } from 'immutable'

const confidentialSelector = state => state.get('confidential')

export const getIsFetching = createSelector(
  confidentialSelector,
  confidentialImmutable => {
    const confidential = confidentialImmutable.toJS()
    return confidential.confidentialCreate.isFetching
    || confidential.confidentialEdit.isFetching
    || confidential.confidentialGet.isFetching
    || confidential.confidentialList.isFetching
    || confidential.confidentialDeactivate.isFetching
    || confidential.confidentialExport.isFetching
    || confidential.confidentialImport.isFetching
  }
)
export const getCreateConfidentialData = createSelector(
  confidentialSelector,
  confidentialImmutable => {
    const confidential = confidentialImmutable.toJS()
    return confidential.confidentialCreate
  }
)
export const getEditConfidentialData = createSelector(
  confidentialSelector,
  confidentialImmutable => {
    const confidential = confidentialImmutable.toJS()
    return confidential.confidentialEdit
  }
)
export const getGetConfidentialData = createSelector(
  confidentialSelector,
  confidentialImmutable => {
    const confidential = confidentialImmutable.toJS()
    return confidential.confidentialGet.confidential
  }
)
export const getListConfidential = createSelector(
  confidentialSelector,
  confidentialImmutable => {
    const confidential = confidentialImmutable.toJS()
    return confidential.confidentialList.confidential
  }
)
export const getDeactivateConfidential = createSelector(
  confidentialSelector,
  confidentialImmutable => {
    const confidential = confidentialImmutable.toJS()
    return confidential.confidentialDeactivate
  }
)
export const getExportURL = createSelector(
  confidentialSelector,
  confidentialImmutable => {
    const confidential = confidentialImmutable.toJS()
    return confidential.confidentialExport.url
  }
)
export const getImportResult = createSelector(
  confidentialSelector,
  confidentialImmutable => {
    const confidential = confidentialImmutable.toJS()
    return confidential.confidentialImport.importResult
  }
)
export const redirectConfidential = createSelector(
  confidentialSelector,
  confidentialImmutable => {
    const confidential = confidentialImmutable.toJS()
    return ({
      redirect: (confidential.confidentialCreate.redirect
      || confidential.confidentialEdit.redirect
      || confidential.confidentialGet.redirect
      || confidential.confidentialList.redirect
      || confidential.confidentialDeactivate.redirect
      || confidential.confidentialExport.redirect
      || confidential.confidentialImport.redirect),
      isAuthenticated: (confidential.confidentialCreate.isAuthenticated
      || confidential.confidentialEdit.isAuthenticated
      || confidential.confidentialGet.isAuthenticated
      || confidential.confidentialList.isAuthenticated
      || confidential.confidentialDeactivate.isAuthenticated
      || confidential.confidentialExport.isAuthenticated
      || confidential.confidentialImport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/confidential/confidential-selector.js